// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"76768d61","600":"9911c742"}[chunkId] + ".chunk.js";
};